import { render, staticRenderFns } from "./ModalIndicationsInfo.vue?vue&type=template&id=1c7a8541&"
import script from "./ModalIndicationsInfo.vue?vue&type=script&lang=js&"
export * from "./ModalIndicationsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports